import React, { useState } from "react";
import { Button, Form, Input, message } from "antd";
import { IoSend } from "react-icons/io5";
import { FaAngleLeft, FaLock } from "react-icons/fa";
import { NavLink, useNavigate } from "react-router-dom";
import { post } from "../../apiService";


export default function PasswordInput({ remberToken }) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleResetPassword = async (value) => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("user_id", remberToken[0]?.user_id);
      formData.append("user_password", value.password);
      formData.append("action", "update_profile")

      const resp = await post("/user.php", formData);

      if (resp) {
        setLoading(false);
        message.success("Password Reset Successfully");
        navigate("/login");
      }
    } catch (error) {
      console.error(error);
      message.error("Unable to reset password please try again");
    }
  };

  return (
    <div className="inputCard">
      <h4>Reset Password</h4>
      <p>Enter your password you want to reset</p>
      <Form layout="vertical" onFinish={handleResetPassword} autoComplete="off">
        <Form.Item
          name="password"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input.Password
            prefix={<FaLock />}
            className="formInput"
            placeholder="Enter Password"
          />
        </Form.Item>
        <Form.Item
          name="confirmPassword"
          rules={[
            {
              required: true,
              message: "Please enter confirm password",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("The new password that you entered do not match!")
                );
              },
            }),
          ]}
        >
          <Input.Password
            prefix={<FaLock />}
            className="formInput"
            placeholder="Confirm Password"
          />
        </Form.Item>
        <Form.Item>
          <Button loading={loading} htmlType="submit" className="addButtons bg-dark text-white" icon={<IoSend />}>
            Reset Passwrod
          </Button>
        </Form.Item>
      </Form>
      <NavLink to="/login">
        <FaAngleLeft /> Back to login page
      </NavLink>
    </div>
  );
}
